

export default {
  listFireWallDO: [],
  totalFireWallDO : 1,
  currentPage : 1,
  per_page : 10,
  showModalAddDroplet : false,
  showModalAddTag : false,
  showModalAddRule : false,
  firewallAddAttribute : null,
}



// WEBPACK FOOTER //
// ./src/store/digital-ocean/moduleFireWall/state.js